import styled from "styled-components";
import { Button as AntButton, Form as AntForm, Input as AntInput } from "antd";

export const ChangePinContainer = styled.div`
	min-height: calc(100vh - 110px);
	display: flex;
	justify-content: flex-start;
	align-items: left;
	flex-direction: column;
	padding: 20px 16px;

	.ant-form-item-label {
		text-align: center;
		font-size: 16px;
	}

	.ant-input {
		text-align: center;
	}
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;

	.ant-form-item {
		margin: 0 0 28px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label {
		margin: 0 auto;
	}

	.ant-form-item-label label {
		color: #004F9C;
		font-size: 14px;
		font-weight: 400;
		line-height: 21px;
		display: flex;
		margin-left: 18px;
	}

	.ant-form-item-explain {
		text-align: center; /* align warning text to the left */
		margin-left: 24px;
		margin-top: 2px;
	}
`;

export const ChangePinTitle = styled.p`
	color: #ffffff;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 25px; /* 156.25% */
	text-align: center;
`;

export const Button = styled(AntButton)`
	width: 100%;
	height: 52px !important;
	border-radius: 26px !important;
	box-sizing: border-box !important ;
	color: #f7f7f7;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	margin-top: 50px;
`;

export const Input = styled(AntInput.Password)`
	border-radius: 26px !important;
	border: 1px solid #0095da !important;
	height: 52px;

	font-size: 16px !important ;
	font-weight: 400;
	line-height: 21px;
	text-align: center;
	color: #000000;

	.ant-input {
		font-size: 17px !important;
		text-align: center;
		color: ${(props) =>
			props.inputType === "phone" ? "#0095DA !important" : "#000000"};
		padding-left: 30px !important;
	}

	.ant-input::placeholder {
		color: rgba(0, 0, 0, 0.30);;
		font-weight: 400;
		font-size: 16px;
	}
`;

export const TitleWrapper = styled.div`
	margin: 0 0 32px 0px;
	background-color: #0095da;
	border-radius: 26px;
	padding: 5px 0;
`;
